import { faEye, faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { BPIFinancialParticularsDetailsForm } from ".";
import { IFinancialParticulars, IFormITR1 } from "../../../config/interfaces";
import { useAppSelector } from "../../../redux/Store";
import { ITRFilingSelector } from "../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";

const BPIFinancialParticularsDetails: React.FC = () => {
  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);

  const { values, setFieldValue, setValues } = useFormikContext<IFormITR1>();

  const FinancialParticularsDetails = values.IncomeDetails?.FinancialParticulars;

  const handleTotalCalculation = (fParicularData: IFinancialParticulars) => {
    const TotalLiabilities = Number(fParicularData?.TotalLiabilities || 0);
    const TotalAssets = Number(fParicularData?.TotalAssets || 0);

    const BPIncomes = {
      ...values.BusOrProfIncomes,
      TotalLiabilities: TotalLiabilities,
      TotalAssets: TotalAssets
    };

    const TotalBusOrProfIncome = Object.values(BPIncomes)?.reduce((acc, curr) => {
      return acc + curr;
    }, 0);

    const DATA = {
      BusOrProfIncomes: BPIncomes,
      TotalBusOrProfIncome: TotalBusOrProfIncome
    };

    setValues({ ...cloneDeep(values), ...DATA });
    setFieldValue("IncomeDetails.FinancialParticulars", fParicularData);
    setFieldValue("LastSavedTimeStamp", new Date().getTime());
  };

  return (
    <>
      <section>
        <div className="section-title-wrap">
          <h5>{`Financial Particulars`}</h5>
          <PreventEditComponent>
            {FinancialParticularsDetails &&
            Number(FinancialParticularsDetails?.TotalLiabilities || 0) +
              Number(FinancialParticularsDetails?.TotalAssets || 0) >
              0 ? (
              <Button
                variant="warning"
                size="sm"
                className="text-white"
                onClick={() => setShowAddFormCanvas(() => true)}
              >
                <FASvgIcon icon={faPen} />
                Edit
              </Button>
            ) : (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowAddFormCanvas(() => true)}
              >
                <FASvgIcon icon={faPlus} />
                Add
              </Button>
            )}
          </PreventEditComponent>

          {isFilingReadOnly && (
            <Button
              variant="warning"
              size="sm"
              className="text-white"
              onClick={() => setShowAddFormCanvas(() => true)}
            >
              <FASvgIcon icon={faEye} />
              View
            </Button>
          )}
        </div>

        {FinancialParticularsDetails ? (
          <dl className="eds-list eds-dl eds-inline-between">
            <RenderListItem
              title="Total Liabilities"
              sum={FinancialParticularsDetails?.TotalLiabilities}
            />

            <RenderListItem title="Total Assets" sum={FinancialParticularsDetails?.TotalAssets} />
          </dl>
        ) : null}
      </section>

      <BPIFinancialParticularsDetailsForm
        showCanvas={showAddFormCanvas}
        handleCloseBtnPress={(fParicularData) => {
          if (fParicularData) {
            handleTotalCalculation(fParicularData);
          }
          setShowAddFormCanvas(() => false);
        }}
        formValues={FinancialParticularsDetails}
      />
    </>
  );
};

export default BPIFinancialParticularsDetails;

const RenderListItem = ({ title, sum = "0" }: { title: string; sum: string }) => {
  const shouldDisplay = sum !== "" && Number(sum) >= 0;
  return (
    <>
      {shouldDisplay && (
        <div className="eds-list--item">
          <dt>{title}</dt>
          <dd>
            <span>
              <PriceDisplay price={sum} />
            </span>
          </dd>
        </div>
      )}
    </>
  );
};
